import React, { Suspense, lazy } from 'react';
import { ArrowRight } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Spline = lazy(() => import('@splinetool/react-spline'));

const HeroSection = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    const element = document.querySelector('#contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToProjects = (e) => {
    e.preventDefault();
    const element = document.querySelector('#projetos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen bg-black overflow-hidden">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-black to-cyan-950/20" />
      
      {/* Grid pattern overlay */}
      <div 
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)
          `,
          backgroundSize: '60px 60px'
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12 pt-32 pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-12 min-h-[calc(100vh-160px)]">
          {/* Left Content */}
          <div className="flex-1 z-10">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-400/10 border border-cyan-400/20 mb-6">
              <div className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse" />
              <span className="text-cyan-400 text-sm font-medium">Soluções em Tecnologia</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              {companyInfo.slogan.split(' ').slice(0, 2).join(' ')}{' '}
              <span className="text-cyan-400">
                {companyInfo.slogan.split(' ').slice(2).join(' ')}
              </span>
            </h1>
            
            <p className="text-lg md:text-xl text-white/70 mb-8 max-w-xl leading-relaxed">
              {companyInfo.tagline}. Desenvolvemos software sob medida e sistemas ERP para impulsionar a transformação digital da sua empresa.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={scrollToContact}
                className="group inline-flex items-center justify-center gap-3 px-8 py-4 bg-cyan-400 text-black font-medium hover:bg-cyan-400/10 hover:text-cyan-400 transition-all duration-400"
              >
                Solicitar Orçamento
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </button>
              
              <button
                onClick={scrollToProjects}
                className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-white/10 text-white font-medium hover:bg-white hover:text-black transition-all duration-400"
              >
                Ver Projetos
              </button>
            </div>

            {/* Stats */}
            <div className="flex gap-12 mt-12 pt-8 border-t border-white/10">
              <div>
                <div className="text-3xl font-bold text-cyan-400">5+</div>
                <div className="text-white/50 text-sm mt-1">Anos de Experiência</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-cyan-400">50+</div>
                <div className="text-white/50 text-sm mt-1">Projetos Entregues</div>
              </div>
              <div>
                <div className="text-3xl font-bold text-cyan-400">30+</div>
                <div className="text-white/50 text-sm mt-1">Clientes Ativos</div>
              </div>
            </div>
          </div>

          {/* Right Content - 3D Spline */}
          <div className="flex-1 relative w-full h-[500px] lg:h-[700px]">
            <div className="absolute inset-0 overflow-visible">
              <Suspense fallback={
                <div className="w-full h-full flex items-center justify-center">
                  <div className="w-16 h-16 border-4 border-cyan-400/30 border-t-cyan-400 rounded-full animate-spin" />
                </div>
              }>
                <Spline scene="https://prod.spline.design/NbVmy6DPLhY-5Lvg/scene.splinecode" />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
